import React from 'react';
import { Box, Typography } from '@mui/material';
import LoadingSpinner from './LoadingSpinner';
import ErrorDisplay from './ErrorDisplay';

interface ContentStateHandlerProps {
  loading: boolean;
  error?: string | null;
  hasContent: boolean;
  emptyMessage: string;
  children: React.ReactNode;
  loadingHeight?: string;
  errorContainer?: React.ComponentType<{ children: React.ReactNode }>;
  emptyContainer?: React.ComponentType<{ children: React.ReactNode }>;
}

const DefaultContainer: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box sx={{ p: 3 }}>{children}</Box>
);

const ContentStateHandler: React.FC<ContentStateHandlerProps> = ({
  loading,
  error,
  hasContent,
  emptyMessage,
  children,
  loadingHeight = "400px",
  errorContainer: ErrorContainer = DefaultContainer,
  emptyContainer: EmptyContainer = DefaultContainer,
}) => {
  if (loading) {
    return <LoadingSpinner height={loadingHeight} />;
  }

  if (error) {
    return (
      <ErrorContainer>
        <ErrorDisplay error={error} />
      </ErrorContainer>
    );
  }

  if (!hasContent) {
    return (
      <EmptyContainer>
        <Typography variant="h6" color="text.secondary">
          {emptyMessage}
        </Typography>
      </EmptyContainer>
    );
  }

  return <>{children}</>;
};

export default ContentStateHandler;
